import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getConfig } from './cookieConfig';
import { useCookiesStore } from './store';

export function useCookieConsent(cookieUrl: string) {
  const { t } = useTranslation('shared');
  const { preferences, configure } = useCookiesStore();

  useEffect(() => {
    if (cookieUrl) {
      configure(getConfig(t, cookieUrl));
    }
  }, [cookieUrl, t]);

  return { preferences };
}
